import QaRolesCustomSelect from './QaRolesCustomSelect.component';

export default QaRolesCustomSelect;
